// @ts-check
import { Appsettings } from "../Appsettings";
import Axios from "axios";

/**
 * @param {number} startDate
 * @param {number} endDate
 * @returns {Promise<any[]>}
 */
export async function getStudiesByDateRange(startDate, endDate) {
  //const url = path.join(
  //  Appsettings.ApiUrl,
  //  `getestudios?inicio=${startDate}&final=${endDate}`,
  //);
  const url =
    Appsettings.ApiUrl +
    "/getestudios?inicio=" +
    startDate +
    "&final=" +
    endDate;
  const req = await Axios.get(url);
  if (req.status !== 200) {
    throw new Error("Error al obtener los estudios");
  }
  const res = req.data;
  return res;
}

/**
 * @param {Object} data
 * @returns {Promise<Object>}
 */
export async function ShareMail(data) {
  //const url = path.join(Appsettings.ApiUrl, `sharecorreo`);
  const url = Appsettings.ApiUrl + "/sharecorreo";
  const req = await Axios.post(url, data);
  if (req.status !== 200) {
    throw new Error("Error al enviar el correo");
  }
  const res = req.data;
  return res;
}

/**
 * @param {string} fileuuid
 * @param {AbortSignal} [signal]
 * @returns {Promise<Blob>}
 */
export async function getDicomFile(fileuuid, signal) {
  //const url = path.join(Appsettings.ApiUrl, `getfiles`, `${fileuuid}`);
  const url = Appsettings.ApiUrl + "/getfiles/" + fileuuid;
  const req = await fetch(url, { signal });
  if (!req.ok) {
    throw new Error("Error al obtener el informe");
  }
  const res = await req.blob();
  return res;
}

/**
 * @param {number | string} ID
 * @returns {Promise<any>}
 */
export async function getStudyByID(ID) {
  //const url = path.join(Appsettings.ApiUrl, `study`, `${ID}`);
  const url = Appsettings.ApiUrl + "/study/" + ID;
  const req = await Axios.get(url);
  if (req.status !== 200) {
    throw new Error("Error al obtener el estudio");
  }
  const res = req.data;
  return res;
}

/**
 * @param {string} nombre
 * @returns {Promise<Blob>}
 */
export async function getReportFile(nombre) {
  //const url = path.join(Appsettings.ApiUrl, `descargarinformever`, `${nombre}`);
  const url = Appsettings.ApiUrl + "/descargarinformever/" + nombre;
  const req = await fetch(url);
  if (!req.ok) {
    throw new Error("Error al obtener el archivo del informe");
  }
  const res = await req.blob();
  return res;
}

/**
 *
 * @param {string} uuid
 */
export function downloadStudyZip(uuid) {
  const url = Appsettings.ApiUrl + "/DescargaEstudio/" + uuid;
  // 1. Creamos un elemento <a> en memoria
  const link = document.createElement("a");

  // 2. Le pasamos la URL de la API
  link.href = url;

  // 3. Forzamos la descarga (esto evita que se abra en el visor del navegador)
  // Nota: El nombre solo funciona si la API es del mismo dominio o tiene CORS bien configurado
  link.setAttribute("download", "estudio-medico.zip");

  // 4. Lo añadimos al DOM (invisiblemente)
  document.body.appendChild(link);

  // 5. Simulamos el clic
  link.click();

  // 6. Lo eliminamos inmediatamente
  document.body.removeChild(link);
}

const StudiesAPI = {
  getStudiesByDateRange,
  ShareMail,
  getDicomFile,
  getStudyByID,
  getReportFile,
};

export default StudiesAPI;
